import { HttpEventType } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { ActionResultModel } from 'src/app/models/common/ActionResultModel';
import { DocumentoResult } from 'src/app/models/common/DocumentoResult';
import { ParametrosMaestro, Roles, TipoCargaPASST, eTypeResult } from 'src/app/models/common/enumModel';
import { CompaniaModel } from 'src/app/models/compania/CompaniaModel';
import { ICargaPasstModel } from 'src/app/models/interfaces/passt/ICargaPasstModel';
import { IFilterSedeModel } from 'src/app/models/interfaces/sedes/IFilterSedeModel';
import { ISedeModel } from 'src/app/models/interfaces/sedes/ISedeModel';
import { ParametroModel } from 'src/app/models/parametros/ParametroModel';
import { CargaPasstModel } from 'src/app/models/passt/CargaPasstModel';
import { FilterSedeModel } from 'src/app/models/sede/FilterSedeModel';
import { SedeModel } from 'src/app/models/sede/SedeModel';
import { AlertDialogService } from 'src/app/services/alert-dialog/alert-dialog.service';
import { CalendarioSsoService } from 'src/app/services/calendario-sso/calendario-sso.service';
import { CargaPasstService } from 'src/app/services/carga-passt/carga-passt.service';
import { ConfirmDialogService } from 'src/app/services/confirm-dialog/confirm-dialog.service';
import { ParametroService } from 'src/app/services/parametros/parametro.service';
import { SedeService } from 'src/app/services/sede/sede.service';
import { StorageService } from 'src/app/services/storage/storage.service';

@Component({
  templateUrl: './passt-planificacion-registrar-dialog.component.html',
  styleUrls: ['./passt-planificacion-registrar-dialog.component.css']
})
export class PasstPlanificacionRegistrarDialogComponent implements OnInit {
  esAdminSSO:boolean = false;
  model: ICargaPasstModel;
  listaAnios: number[];
  listaSedes: ISedeModel[] = new Array<SedeModel>();
  listaCompanias: CompaniaModel[] = new Array<CompaniaModel>();
  listaTipos: ParametroModel[] = new Array<ParametroModel>();
  constructor(public dialogRef: MatDialogRef<PasstPlanificacionRegistrarDialogComponent>,
    private storage: StorageService,
    private confirmDialogService: ConfirmDialogService,
    private alertDialogService: AlertDialogService,
    private parametroService: ParametroService,
    private sedeService: SedeService,
    private serviceCalendario: CalendarioSsoService,
    private service: CargaPasstService) { 
      this.model=new CargaPasstModel();
      this.listaAnios = new Array<number>();
      this.model.anio = new Date().getFullYear();
      let usuario = this.storage.getCurrentUser();
      this.listaCompanias = usuario.companias;
      this.model.idCompaniaSelected = usuario.companiaDefault.idCompania;
    }

  ngOnInit(): void {
    let usuario = this.storage.getCurrentUser();
    if(usuario.selectedRoles){
      this.esAdminSSO = usuario.selectedRoles.find(p => p === Roles.ADMINISTRADORSSO)? true : false;
    }
    this.serviceCalendario.getAnios()
    .subscribe((data: number[]) => {
      this.listaAnios = data;
    });
    this.companiaChanged();
    if(this.esAdminSSO){
      this.parametroService
      .getDetalles(ParametrosMaestro.TIPO_CARGA_PASST)
      .subscribe((p) => {
        this.listaTipos = p.items;
      });
    }
    else{
      let tipoprog = new ParametroModel();
      tipoprog.idParametroDetalle=TipoCargaPASST.Programacion;
      tipoprog.nombre="Programacion";
      tipoprog.valor="Programacion";
      this.listaTipos.push(tipoprog);
      this.model.idTipoCargaSelected=TipoCargaPASST.Programacion;
    }
  }

  companiaChanged() {

    this.listaSedes = [];
    this.model.idSedeSelected = undefined;
    let filterSede: IFilterSedeModel = new FilterSedeModel();
    filterSede.companias.push(this.model.idCompaniaSelected?this.model.idCompaniaSelected:0);

    this.sedeService
      .getList(filterSede)
      .subscribe((data: ISedeModel[]) => {
        this.listaSedes = data;
      });
  }

  onNoClick(): void {
    this.dialogRef.close();
  }  
  
  
  onSubmit(form: NgForm) {
    
    if (!form.invalid) {      
      
      
      if (this.model.nombreArchivo == '') {
        this.alertDialogService.open('Debe seleccionar el archivo a cargar');
      } else {
        this.confirmDialogService.open('¿Seguro que desea cargar su programa PASST?'); //options
          this.confirmDialogService.confirmed().subscribe((confirmed) => {
            if (confirmed) {  
              this.model.idCompania=this.model.idCompaniaSelected!=null?this.model.idCompaniaSelected:0;
              this.model.idSede=this.model.idSedeSelected!=null?this.model.idSedeSelected:0;
              this.model.idTipoCarga=this.model.idTipoCargaSelected!=null?this.model.idTipoCargaSelected:0;
              this.service.submit(this.model).subscribe((result: ActionResultModel) => {
                console.log(result);
                if(result.type!=eTypeResult.SUCCESS){
                  this.alertDialogService.open(result.message);
                }else{
                  this.dialogRef.close(this.model);
                }
              });
            }
          });
        
      }
    }
  }

  public uploadFile = (files: any) => {
    if (files.length === 0) {
      return;
    }
    let fileToUpload = <File>files[0];
    const formData = new FormData();
    formData.append('file', fileToUpload, fileToUpload.name);
    
    this.service
    .upload(formData, this.model.anio.toString())
    .subscribe((event) => {
      if (event.type === HttpEventType.UploadProgress) {
        // this.progress = Math.round(100 * event.loaded / event.total);
      } else if (event.type === HttpEventType.Response) {
        // this.filename = fileToUpload.name;
        // this.message = 'Upload success.';
        if(event.body){
          const doc: DocumentoResult = JSON.parse(JSON.stringify(event.body))
          this.model.nombreArchivo = doc.fileName;
          this.model.rutaArchivo = doc.dbPath;
        }
      }
    });
  }
}
